module.exports = __webpack_public_path__ + "img/Stevan_Rudinac@2x.b4b14870.png";